import { adEditorOverrideStyle } from '@bingads-webui-campaign-react/ad-editor-styles';

export const getRSAStyles = (_, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  rsa: {
    ...adEditorOverrideStyle({ palette, iconFontFamily }),

    '& .rsa-left-copilot-column': {
      width: '600px',
      minWidth: '600px',
    },
  },
});
